import { snakeCase } from 'lodash';

function billingDetails() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./billing-details.html'),
    controller: 'BillingDetailsController',
    controllerAs: 'vm',
    bindToController: {
      onUpdate: '&'
    }
  };
}


function BillingDetailsController(countries, Account, Helper) {
  'ngInject';
  var vm = this;

  vm.countries = countries;
  vm.canSelectCurrency = false;

  vm.save = save;
  vm._sanitizeVendor = _sanitizeVendor;

  Account.getCurrent()
    .then(_prepare);

  /**
   * Prepares view variables
   *
   * @param {Object} account
   * @private
   */
  function _prepare(account) {

    vm.account = Object.assign({}, account, {address_attributes: account.address});

    if (vm.account.billing_currency) {
      return;
    }

    vm.canSelectCurrency = true;
    vm.currencies = Account.getCurrencies(_sanitizeVendor(vm.account.vendor));
    vm.account.billing_currency = vm.currencies[0].name;

  }

  /**
   * Sanitizes a vendor name
   *
   * @param {String} vendorName
   * @returns {String}
   * @private
   */
  function _sanitizeVendor(vendorName) {

    return snakeCase(vendorName.toLowerCase());

  }

  /**
   * Saves billing details
   */
  function save() {

    if (vm.form.$invalid) { return; }

    vm.disabled = true;

    Account.update(vm.account.id, vm.account)
      .then(function(account) {

        vm.onUpdate({account: account});

      }, function(result) {

        vm.disabled = false;

        vm.error = Helper.getErrorMessage(result.data);

      });

  }
}

export { BillingDetailsController, billingDetails };
